import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import Heading from "../ui/Heading";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";
import customeDesignImg from '../../../../../Assets/adore-imgs/collection/custom-order-banner.jpg'
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const CustomDesign = () => {
    const history = useHistory();
  return (
    <section className="custom-design">
      <Container fluid className="showcase-container custome_sec">
        <Row className="align-items-center">
         

          <Col md={5} xs={12} className="order-2 order-md-1 order-sm-2">
            <Heading className="text-lg-left w-100">
              <span className="text-uppercase">Our Services</span>
              <h2 className="text-uppercase">Custom Design Services </h2>
              <p>
              We provide services for custom designing and repairing fine jewelry. We offer complete service on watches, including Rolex by certified watchmakers. The purchase of any fine jewelry piece is accompanied by lifetime cleaning service.
              </p>
            </Heading>

             <div className=" text-center text-md-center text-lg-left mt-md-4">
              <button className="button_black_border"
                    onClick={()=> history.push("/custom-design")}
                  >
                Discover More
                  </button>
            </div>
          </Col> 
          <Col md={7} xs={12} className="text-center order-1 order-md-2 order-sm-1">
            <Image src={customeDesignImg} alt="Custom Design Jewelry" className="img-fluid"/>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CustomDesign;
